import {BranchAction} from '@/store/branch/branch.actions';
import {Branch, BranchInitState} from '@/store/branch/branch.types';
import {BranchMutations} from '@/store/branch/branch.mutations';

const namespaced = true;

export const branchInitState: BranchInitState = {
  branchs: [{}] as Branch[]
};

export const branchState = {
  namespaced,
  state: branchInitState,
  actions: BranchAction,
  mutations: BranchMutations,
  // getters
};
